import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { createTuinaPurchaseOrder } from '@/service/tuina'
import PurchaseOrderForm from './PurchaseOrderForm'
import PurchasePayModal from './PurchasePayModal'

const fromValue = (fields) => ({
  projectId: fields.projectId,
  memberId: fields.memberId,
  quantity: fields.quantity,
  payMethod: fields.payMethod,
  remark: fields.remark == null ? '' : fields.remark
})

class PurchaseOrderModal extends React.Component {
  payModalRef = React.createRef()

  static propTypes = {
    children: PropTypes.node,
    record: PropTypes.object,
    memberId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    storeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabledModal: PropTypes.bool,
    zIndex: PropTypes.number,
    onSuccess: PropTypes.func
  }

  handleOk = async (form) => {
    const fields = await form.current.validateFields()
    const formatFields = fromValue(fields)
    const response = await createTuinaPurchaseOrder(formatFields)
    const data = response.data
    const orderNo = data && typeof data === 'object' ? data.orderNo : data
    if (!orderNo) {
      message.error('未返回订单号')
      return
    }
    this.pendingProjectId = formatFields.projectId
    const { onSuccess } = this.props
    if (typeof onSuccess === 'function') onSuccess(formatFields.projectId)
    this.payModalRef.current.show(orderNo, formatFields.payMethod)
  }

  handlePaySuccess = () => {
    const { onSuccess } = this.props
    if (typeof onSuccess === 'function') onSuccess(this.pendingProjectId)
  }

  render () {
    const { children, record, memberId, storeId, disabledModal, zIndex } = this.props
    const projectName = (record && record.name) || ''
    return (
      <>
        <WrappedModal
          children={children}
          title={projectName ? `下单 ${projectName}` : '下单'}
          okText="提交"
          okButtonProps={{ size: 'large' }}
          cancelButtonProps={{ size: 'large' }}
          width={560}
          zIndex={zIndex}
          disabledModal={disabledModal}
          baseComponent={<PurchaseOrderForm />}
          baseProps={{ record, memberId, storeId }}
          onOk={this.handleOk}
        />
        <PurchasePayModal
          ref={this.payModalRef}
          zIndex={(zIndex || 1000) + 100}
          onSuccess={this.handlePaySuccess}
        />
      </>
    )
  }
}

export default PurchaseOrderModal

